export default {"src":"/_next/static/image/public/images/ic_radiology_image.4fb79bb098b512b0c86188196e5fbb21.svg","height":36,"width":36};